(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ol-home"] && !Shopify.designMode) return;
  try {
    
function initCharacterSelect(root){if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-select-look]').forEach((button,index)=>button.addEventListener('click',()=>{root.querySelectorAll('[data-select-look]').forEach(el=>{el.classList.toggle('is-active',el===button);el.setAttribute('aria-pressed',String(el===button));});root.querySelectorAll('[data-look]').forEach(el=>el.classList.toggle('is-active',el.dataset.look===button.dataset.selectLook));root.querySelector('[data-selected-title]').textContent=button.dataset.title;root.querySelector('[data-selected-price]').textContent=button.dataset.price;root.querySelector('[data-selected-link]').href=button.dataset.url;root.querySelector('.ol-stage-bottom span:last-child').textContent=String(index+1).padStart(2,'0')+' / 05';}));}
document.querySelectorAll('[data-character-select]').forEach(initCharacterSelect);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-character-select]').forEach(initCharacterSelect));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ol-product"]) return;
  try {
    
function initLookGalleries(context){context.querySelectorAll('[data-ol-gallery]').forEach(gallery=>{if(gallery.dataset.galleryReady)return;gallery.dataset.galleryReady='true';const main=gallery.querySelector('[data-ol-main-image]');gallery.querySelectorAll('[data-ol-photo]').forEach(button=>button.addEventListener('click',()=>{const source=button.dataset.olPhoto;main.srcset=source.replace('width=1500','width=400')+' 400w, '+source.replace('width=1500','width=800')+' 800w, '+source+' 1500w';main.src=source;gallery.querySelectorAll('[data-ol-photo]').forEach(thumb=>{thumb.classList.toggle('is-active',thumb===button);thumb.setAttribute('aria-pressed',String(thumb===button));});gallery.querySelector('[data-ol-photo-count]').textContent=button.dataset.photoNumber+' / 02';}));});}
initLookGalleries(document);document.addEventListener('shopify:section:load',event=>initLookGalleries(event.target));
document.querySelectorAll('[data-ol-product]').forEach(root=>{const select=root.querySelector('[data-ol-variant]');select?.addEventListener('change',()=>{const option=select.selectedOptions[0];root.querySelector('[data-ol-price]').textContent=option.dataset.price;const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);});});

  } catch(e) { console.error(e); }
})();
})();
